import loadable from '@loadable/component';
import {
    root,
    ICachedComponentsRegistry,
    IComponentRegistry,
    IComponentViewController,
    RegisteredComponent
} from 'elc-universal-utils';
import { ServiceBusController } from './ServiceBusController';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IAppConfig = any;
export type ServiceInitializer = (config: IAppConfig) => ServiceBusController | void;

export abstract class Service {
    public name: string;
    public version: string;
    public serviceBusController: ServiceBusController;
    public componentsRegistry: IComponentRegistry = {};
    public cachedComponentsRegistry: ICachedComponentsRegistry = {};
    protected serviceInitializer: ServiceInitializer;
    public isStarted: boolean = false;
    constructor(name: string, version: string, serviceInitializer: ServiceInitializer) {
        this.name = name;
        this.version = version;
        this.serviceInitializer = serviceInitializer;
    }
    public async start(appConfig: IAppConfig) {
        if (!this.isStarted) {
            this.serviceInitializer(appConfig);
            this.isStarted = true;
        }
    }

    public register = () => {
        root.ServiceRegistry = root.ServiceRegistry || {};
        root.ServiceRegistry[this.name] = Object.assign(root.ServiceRegistry[this.name] || {}, {
            start: this.start,
            name: this.name,
            version: this.version,
            getView: this.getView,
            registerView: this.registerView,
            setViewInCache: this.setViewInCache,
            getViewFromCache: this.getViewFromCache,
            serviceInitializer: this.serviceInitializer,
            componentsRegistry: this.componentsRegistry,
            cachedComponentsRegistry: this.cachedComponentsRegistry,
            isStarted: this.isStarted
        });
    };

    public getView = (componentName: string) => {
        return this.componentsRegistry[componentName];
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public setViewInCache = (componentName: string, component: React.ComponentType<any>) => {
        this.cachedComponentsRegistry[componentName] = component;
    };

    public getViewFromCache = (componentName: string) => {
        return this.cachedComponentsRegistry[componentName];
    };

    public registerView = (
        componentName: string,
        component: RegisteredComponent,
        viewController?: () => IComponentViewController
    ) => {
        this.componentsRegistry[componentName] = {
            componentName,
            component: loadable(component),
            viewController
        };
    };
}
